import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

// Don't forget to update CONNECT_ROUTES_SET in @jira/platform__common-constants/src/spa-routes
export const connectGeneralServiceDeskProjectRoute: InvariantJiraRoute = {
	name: 'connect-general-service-desk-project',
	path: '/plugins/servlet/ac/:addonKey/:moduleKey',
	query: [
		'mobile?!=true',
		'includeWebResources?!=true',
		'classifier?!=json',
		'project.key?',
		'project.id?',
		'project.key',
		'servicedesk.serviceDeskId',
	],
};
